<template>
        <crud-update :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @update="update"
                 @close="$emit('close')"
    >
         <stock-transaction-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-update>
</template>

<script>

    import StockTransactionProvider from "../../../../providers/StockTransactionProvider";
    
    import {CrudUpdate, ClientError} from '@dracul/common-frontend'
    
    import StockTransactionForm from "../StockTransactionForm";
  
    

    export default {
        name: "StockTransactionUpdate",
        
        components: { StockTransactionForm, CrudUpdate },
        
        props:{
          open: {type: Boolean, default: true},
          item: {type: Object, required: true}
        },

        data() {
            return {
                title: 'delivery.stockTransaction.editing',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                id: this.item.id,
                form: {
                    branch: this.item.branch ? this.item.branch.id : null,
                    branchDestination: this.item.branchDestination ? this.item.branchDestination.id : null,
                    operation: this.item.operation,
                    reason: this.item.reason,
                    items: this.item.items ? this.item.items.map(i=> i.id?i.id:i) : null,
                    user: this.item.user ? this.item.user.id : null
                }
            }
        },
        methods: {
            update() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    StockTransactionProvider.updateStockTransaction(this.id, this.form).then(r => {
                            if (r) {
                                this.$emit('itemUpdated',r.data.updateStockTransaction)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }
        },
    }
</script>

<style scoped>

</style>

